import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService } from '../../services/event.service';

@Component({
  selector: 'app-registration-complete',
  templateUrl: './registration-complete.component.html',
  styleUrls: ['./registration-complete.component.less']
})
export class RegistrationCompleteComponent implements OnInit {
  private eventKey: string;

  constructor(private route: ActivatedRoute,
    private eventService: EventService) {
    this.route.params.subscribe((p) => {
      this.eventKey = p['eventKey'];
    });
   }

  ngOnInit() {
    this.eventService.get(this.eventKey)
      .then((result) => {

      });
  }
}
